import { ComponentPropsWithRef } from "react"
import { cn } from "@/utils/classname"
import { Icon } from "../icons/Icon"

interface SearchFieldProps extends Omit<
	ComponentPropsWithRef<"input">,
	"value" | "defaultValue" | "onChange" | "type"
> {
	value: string
	onChange: (value: string) => void
	"aria-label": string
}

export const SearchField = ({ value, onChange, className, ...inputProps }: SearchFieldProps) => {
	return (
		<div className={cn("relative flex w-64 items-center", className)}>
			<input
				{...inputProps}
				type="search"
				value={value}
				onChange={(event) => onChange(event.target.value)}
				className="electron-no-drag h-7 w-full min-w-0 rounded-md bg-base-700 py-1 pl-8 pr-2 text-sm text-base-50 placeholder:text-base-400"
			/>
			<Icon
				className="pointer-events-none absolute left-2 text-base-400"
				name="search"
				size={16}
				aria-hidden="true"
			/>
		</div>
	)
}
